module.exports = __webpack_public_path__ + "media/icons/key-space-0f352b4b.svg";